// Checker
import { check, submit, measureWeb } from 'mondrian-checker';

const measureEndPoint = 'https://blyhax9weg.execute-api.us-east-1.amazonaws.com'

function startMeasurer() {
  try {
    const TUESDAY = 2;
    const today = new Date();
    const isDayToMeasure = today.getDay() === TUESDAY
    if(!isDayToMeasure) return
    check(window.location.href, measureEndPoint).then(runMeasure);
  } catch (error) {
   console.log("Mondrian: Measure cancelled.");
  }

  async function runMeasure(data) {
    if (!data.canMeasure) return;
    const measureData = await measureWeb(document, {});
    submit(measureData, measureEndPoint).then(putResponse => putResponse);
  }
}

export default startMeasurer
